/* eslint-disable @typescript-eslint/no-explicit-any */
import type { SVGAttributes } from 'react'

import type { FlexProps } from '../flex/types'
import type { SizeProps } from '../types'

// g-icon = goggle icon, mui = material-ui
export type SvgIcon =
  | 'check'
  | 'filter'
  | 'close'
  | 'search'
  | 'info'
  | 'analytic'
  | 'map'
  | 'list'
  | 'favorite'
  | 'expand'
  | 'add'
  | 'remove'
  | 'circle'
  | 'select'
  | 'selected'
  | 'arrowUp'
  | 'arrowDown'
  | 'chevronLeft'
  | 'chevronRight'
  | 'chevronDown'
  | 'chevronUp'
  | 'chevronUpDouble'
  | 'chevronDownDouble'
  | 'chevronLeftDouble'
  | 'chevronRightDouble'
  | 'star'
  | 'pin'
  | 'costarLogo'
  | 'costarWheel'
  | 'poweredByCostar'
  | 'apartmentsLogo'
  | 'poweredByApartments'
  // | 'mui-arrowDownward'
  | 'mui-arrowDropDown'
  | 'mui-person'
  // | 'mui-cancel'
  // | 'mui-checkBox'
  // | 'mui-checkBoxOutlineBlank'
  // | 'mui-checkCircle'
  // | 'mui-close'
  // | 'mui-indeterminateCheckBox'
  | 'mui-keyboardArrowLeft'
  | 'mui-keyboardArrowRight'
  | 'mui-person'
  | 'mui-radioButtonChecked'
  | 'mui-radioButtonUnchecked'
  | 'mui-moreHoriz'
  | 'mui-warning'
  | 'cameraShutter'
  | 'dslrCamera'
  | 'print'
  | 'papers'
  | 'headShot'
  | 'mail'
  | 'alert'
  | 'g-icon-add'
  | 'g-icon-remove'
  | 'question-with-boarder'
  | 'download'
  | 'lock'
  | 'unlock'
  | 'document'
  | 'thickCircle'
  | 'slashCircle'
  | 'gallery'
  | 'copy'
  | 'calendar'
  | 'costarMarker'
  | 'exclamation'
  | 'share'
  | 'updatePencil'
  | 'locationHQ'

export type SvgIconProps = {
  id?: string
  strokeWidth?: number
  filter?: string
  /**
   * fill can be use to override svg 'currentcolor' fill color or for icon that support partial fill
   *  faction number of 0 to 1 can be used to provide fraction fill color using the 'currentcolor'
   */
  fill?: string | number
  /**
   * use for icon that support dual color for partial fill
   */
  secondaryColor?: string
  disabled?: boolean
}

export type Props = SvgIconProps & {
  /** The name of your icon. */
  icon: SvgIcon
  /** Size of the icon. */
  size?: SizeProps
  /**
   * use font sizing when it needs to be
   */
  useFontSize?: boolean
  /** unset size to let svg response to the container size */
  openSize?: boolean
  /** enabled glow effect on hover */
  glowEffect?: boolean
  /** show highlighted state enable glow effect independent of hover*/
  highlight?: boolean
  /** subscribe to hover event true for entering false for leaving */
  onHover?: (entered?: boolean, eventSource?: HTMLDivElement) => void
  /**
   * by default icon svg will be wraps in a div, set to true remove wrapper
   */
  noWrapper?: boolean
}
export type PropsWithA11yHidden = Props & {
  /** Indicates that this element should be skipped by assistive technologies. */
  a11yHidden?: boolean
}
export type PropsWithA11yLabel = Props & {
  /** A label for the icon which can be read by screen readers. This is required if a11yHidden is false. */
  a11yLabel?: string
}
export type LocalIconProps = PropsWithA11yHidden | PropsWithA11yLabel
export type IconProps = Omit<FlexProps, 'size'> &
  LocalIconProps & {
    viewBox?: SVGAttributes<SVGElement>['viewBox']
  }

export type ToggleFlipIconProps = IconProps & {
  toggleState?: boolean
  /**
   * provide initial icon orientation in degree default is 0
   */
  initialIconOrientation?: number
  /**
   * rotate icon x degree when toggle default is 180
   */
  rotateIconOnToggle?: number
}

export function isIconProps(subject: any): subject is IconProps {
  return typeof subject === 'object' && 'icon' in subject
}
